import React from "react";

export type QuestionContent = {
  photo: string;
  caption: React.ReactNode;
  correctAnswer: number;
  otherChoices: number[];
};

export const getResultsText = () => 
  [
    "Stand clear of the closing doors, please.", // Score: 0/10
    "Stand clear of the closing doors, please.", // Score: 1/10
    "Stand clear of the closing doors, please.", // Score: 2/10
    "You are being momentarily held by a signal error.", // Score: 3/10
    "You are being momentarily held by a signal error.", // Score: 4/10
    "You are being momentarily held by a signal error.", // Score: 5/10
    "You’re in a New York State of Mind.", // Score: 6/10
    "You’re in a New York State of Mind.", // Score: 7/10
    "All signals are green, service is good.", // Score: 8/10
    "All signals are green, service is good.", // Score: 9/10
    "Congratulations! You know as much about the subway as THE CITY’s transit reporter, Jose Martinez.", // Score: 10/10
  ];
;

export const getQuizContent: () => QuestionContent[] = () => [
  {
    photo: require("../assets/images/q1.jpg"),
    caption: <>This piece of art titled "Railrider's Throne" can be found in which station?</>,
    correctAnswer: 307,
    otherChoices: [273, 51, 164],
  },
  {
    photo: require("../assets/images/q3.jpg"),
    caption: (
      <>
        This two-level station links commuters with JFK Airport, and part of its name is in the title of a song by Brooklyn-based artist Blood Orange.
      </>
    ),
    correctAnswer: 279,
    otherChoices: [278, 195, 185],
  },
  {
    photo: require("../assets/images/q2.jpg"),
    caption: (
      <>
        At 173 feet below street level, this the deepest station in the subway system. Its kaleidoscopic graffiti was recently painted over.
      </>
    ),
    correctAnswer: 300,
    otherChoices: [471, 234, 145],
  },
  
  {
    photo: require("../assets/images/q4.jpg"),
    caption: (
      <>
        This is the closest station to what used to be Ebbets Field — the Flatbush home of the Brooklyn Dodgers until 1957, when they moved to L.A.
      </>
    ),
    correctAnswer: 42,
    otherChoices: [244, 277, 43],
  },
  {
    photo: require("../assets/images/q5.jpg"),
    caption: (
      <>
        Originally opened as a Long Island Railroad stop, this is the busiest of all the stations on the Rockaway peninsula, especially on good beach days.
      </>
    ),
    correctAnswer: 209,
    otherChoices: [203, 55, 199],
  },
  {
    photo: require("../assets/images/q6.jpg"),
    caption: (
      <>
        Which was Brooklyn's first underground subway station?
      </>
    ),
    correctAnswer: 620,
    otherChoices: [39, 235, 120],
  },
  {
    photo: require("../assets/images/q7.jpg"),
    caption: (
      <>
        You can see the Manhattan skyline even while underground at this station — in a 2005 mosaic titled "Look Up, Not Down."
      </>
    ),
    correctAnswer: 273,
    otherChoices: [238, 1, 458],
  },
  {
    photo: require("../assets/images/q8.jpg"),
    caption: (
      <>
        Which stop was the least-used station in the subway system in 2022 — with a total yearly ridership of under 50,000?
      </>
    ),
    correctAnswer: 199,
    otherChoices: [196, 202, 318],
  },
  {
    photo: require("../assets/images/q9.jpg"),
    caption: (
      <>
        At which elevated Bronx station along the No. 6 line can one take in the bridge and river vistas through the steel platform sculptures that make up "Bronx River View"?
      </>
    ),
    correctAnswer: 370,
    otherChoices: [365, 368, 366],
  },
  {
    photo: require("../assets/images/q10.jpg"),
    caption: <>Where in the subway system do "pigs fly" — at least across a few station tiles?</>,
    correctAnswer: 397,
    otherChoices: [399, 42, 449],
  }
];
